<div class="modal-header">

  <h4 class=" mb-3">
    Who's Viewed Your Profile <span class="badge bg-primary-subtle text-primary fw-semibold fs-7">(Last 30 Days)</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="mb-5">

  <div *ngIf="allUserIds">
    <!-- Empty State -->
    <div *ngIf="!allUserIds.length" class="text-center py-5 text-muted">
      <i class="bi bi-people fs-3 mb-2 d-block"></i>
      No one has viewed your profile yet.
    </div>

    <!-- Table Wrapper -->
    <div *ngIf="allUserIds.length" class="table-responsive " style="max-height: 400px; overflow-y: auto;">
      <table class="table align-middle mb-0">
        <thead class="bg-light text-muted fw-semibold sticky-top" style="z-index: 2;">
          <tr>
            <th scope="col"></th>
            <th scope="col">Viewer</th>
            <th scope="col">Viewed On</th>
            <th scope="col">View count</th>

          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of allUserIds; let i = index" class="border-bottom hover-bg-light clickable-row"
            (click)="openDetailsView(data)">
            <td class="text-secondary"></td>

            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-3 p-1 border border-gray-300 rounded bg-white">
                  <img *ngIf="data?.viewerAvatar" [src]="data?.viewerAvatar | imagekitUrlAppender"
                    alt="{{ data.viewerName }}" class="rounded" width="45" height="45" />
                  <ngx-avatars *ngIf="!data?.viewerAvatar" [name]="data?.viewerName || 'Unknown User'" bgColor="#eaeaea" size="45"
                    cornerRadius="4" [round]="false"></ngx-avatars>
                </div>

                <div class="d-flex flex-column">
                  <span class="text-dark fw-semibold fs-6">
                    {{ (data?.viewerName | titlecase) || 'Unknown User' }}
                  </span>
                  <span class="text-muted fs-7">
                    {{ (labelMap[data?.viewerAccountType] || data?.viewerAccountType) | titlecase }}
                  </span>
                </div>
              </div>
            </td>

            <td class="text-muted fs-7">
              <i class="bi bi-clock me-1 text-gray-400"></i>
              {{ daysPassed(data?.lastViewedAt) }} ago
            </td>

            <td>
              <span class="badge bg-primary-subtle text-primary fw-semibold fs-7">
                {{data?.totalViews || 0}}
              </span>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
</div>